import { Backdrop, CircularProgress, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';

const BackdropLoader = (props) => {
  const { isLoading, retry = () => window.location.reload() } = props;
  const [isRetry, setIsRetry] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsRetry(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);
  return (
    <Backdrop sx={{ color: '#fff', zIndex: 999 }} open={Boolean(isLoading)}>
      <Stack alignItems='center'>
        <CircularProgress color='inherit' />
        <p style={{ fontSize: '10px' }} className='mt-2'>
          {isLoading}
        </p>
      </Stack>
    </Backdrop>
  );
};

export default BackdropLoader;
